import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})

export class TalukService {

  is_display_taluk_register_component = false;
  TalukUpdate = new EventEmitter<ZONE>();

  downloadTaluk = new EventEmitter<boolean>();

  private _taluk_data: TALUKTYPE = null;
  constructor() { }

  set set_taluk_data(taluk) {
    this._taluk_data = taluk;
  }

  get get_taluk_data() {
    return this._taluk_data;
  }
}

export interface TALUKTYPE {
  id: number;
  name: string;
}
